<template>
    <div class="mt-5 md:mt-0 md:col-span-2 bg-white shadow-md rounded-md ">
        <form @submit.prevent="$emit('submitted')">
            <div class="px-4 py-5 sm:p-6 shadow"
                :class="hasActions ? 'sm:rounded-tl-md sm:rounded-tr-md' : 'sm:rounded-md'">
                <div class="grid grid-cols-6 gap-6">
                    <slot name="form"></slot>
                </div>
            </div>

            <div class="flex items-center justify-end px-4 py-3 bg-gray-50 dark:bg-gray-700 text-right sm:px-6 shadow sm:rounded-bl-md sm:rounded-br-md" v-if="hasActions">
                <slot name="actions"></slot>
            </div>
        </form>
    </div>
</template>

<script>
    import { defineComponent } from 'vue'

    export default defineComponent({
        emits: ['submitted'],

        computed: {
            hasActions() {
                return !! this.$slots.actions
            }
        }
    })
</script>
